<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="'Восстановить'" (onOk)="ok()" >
	<p>Возобновить работу сайта <strong>{{title}}</strong>?</p>
</base-support-modal>

